// this component is handling the user card for login user
import cx from 'classnames';
import { useState, useEffect, memo } from 'react';
import { Card, Nav, Image } from 'react-bootstrap';
import Toggle from 'react-bootstrap-toggle';
import 'react-bootstrap-toggle/dist/bootstrap2-toggle.css';
import { matchPath, useLocation, useNavigate } from 'react-router-dom';
import { icons } from '../assets';
import { ADD_CREDITS_ROUTE } from '../config/constant/routePathConstant';
import { USER_MENU } from '../constants/menu';
import { useUserContext } from '../contexts/UserContext';
import { apiGetUserDetails } from '../helpers/api';
import { errorToast, warningToast } from '../helpers/toastHelper';
import { useStaticPermissions } from '../hooks/usePermissions';
import { Mixpanel, MxEvent } from '../common/Mixpanel';
import { useCheckCuratorActive } from '../hooks/useCuratorActive';
import { CommonFeatureMenu } from '../layouts/Sidemenu';

const { UserIcon } = icons;

const UserCard = memo(({ cardFlag, setUserCardVisiblity, handleClosePopUp , isGuestLogin }) => {
  // const location = useLocation();
  const { currentUser, logout } = useUserContext();
  // const { hasPermission } = useStaticPermissions();
  // const { isCuratorActive } = useCheckCuratorActive();

  // const navigate = useNavigate();
  const [themeMode, setThemeMode] = useState(false);

  const handleUserCard = (e) => {
    e.stopPropagation();
    handleClosePopUp();
    setUserCardVisiblity(!cardFlag);
  };

  const onToggle = (e) => {
    setThemeMode(!themeMode);
  };

  // const canAddCredits = async (path) => {
  //   const userDetails = await apiGetUserDetails();
  //   if (userDetails) {
  //     const { country, state, city } = userDetails;
  //     if (country && (state || city)) {
  //       navigateAndCloseMenu(path);
  //     } else {
  //       warningToast('Please fill your basic details to proceed with Add Credits.');
  //     }
  //   }
  // };

  // function handleLink(path) {
  //   if (path === ADD_CREDITS_ROUTE) {
  //     canAddCredits(path);
  //   } else {
  //     navigateAndCloseMenu(path);
  //   }
  // }

  // function navigateAndCloseMenu(path) {
  //   navigate(path);
  //   setUserCardVisiblity(false);
  // }

  // async function handleLogout() {
  //   const curatorActive = await isCuratorActive();
  //   if (curatorActive) {
  //     errorToast('Please close or save any open project before logging out.');
  //     return;
  //   }

  //   Mixpanel.track(true, MxEvent.LOGIN_OUT_SUCCESS);

  //   Mixpanel.reset();
  //   console.log('mx: reset');

  //   Mixpanel.track(true, MxEvent.VISITED_LOGIN);

  //   logout();
  //   setUserCardVisiblity(false);
  // }

  const handleHidePopover = () => {
    setUserCardVisiblity(false);
  };

  useEffect(() => {
    if (cardFlag) {
      window.addEventListener('click', handleHidePopover);
    }

    return () => {
      window.removeEventListener('click', handleHidePopover);
    };
  }, [cardFlag]);

  return (
    <div className="user-card">
      <button className="user-card-btn" onClick={handleUserCard}>
        {currentUser && currentUser?.user?.profile_image ? <UserIcon /> : <UserIcon />}
      </button>
      <Card className={cardFlag ? '' : 'hide'}>
        <Card.Body>
          <h6 className="user-email">
            {isGuestLogin ? "Guest User" : currentUser?.user?.email || currentUser?.organization_detail?.billing_email}
          </h6>

          <CommonFeatureMenu
            navList={isGuestLogin ? USER_MENU?.slice(1) : USER_MENU}
            className="bg-transparent pt-0 pb-0"
            menuClassName="flex-column gap-0"
            menuItemClassName="px-0"
            style={{ margin: '0 -0.5rem' }}
          />
          {/* <Nav as="ul" className="menu">
            {USER_MENU.map((item, i) => {
              const Icon = item?.icon;

              if (item?.permission && !hasPermission(item?.permission)) return null;

              return (
                <Nav.Item
                  role="button"
                  as="li"
                  key={item.path}
                  className={cx({
                    active: matchPath({ path: item.path }, location?.pathname) !== null,
                  })}>
                  <a
                    className="nav-link"
                    onClick={() => {
                      item.name === 'Logout' ? handleLogout() : handleLink(item.path);
                    }}>
                    <Icon />
                    <span>{item.name}</span>
                  </a>
                </Nav.Item>
              );
            })}
          </Nav> */}
        </Card.Body>
        {/* uncomment this when we work on dark mode */}
        {/* <Card.Body className="theme-mode">
          <Nav as="ul" className="menu">
            <Nav.Item as="li" className="theme-mode-switcher" onClick={(e) => e.stopPropagation()}>
              <span className="theme-label">{themeMode ? 'Dark' : 'Light'} Mode </span>
              <Toggle
                onClick={onToggle}
                on={<span className="text">ON</span>}
                off={<span className="text">OFF</span>}
                width="40px"
                height="20px"
                size="xs"
                offstyle="danger"
                active={themeMode}
              />
            </Nav.Item>
          </Nav>
        </Card.Body> */}
      </Card>
    </div>
  );
});

export default UserCard;
